import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Something went wrong");
      setSuccess(true);
      setTimeout(() => navigate("/"), 2500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-sm text-center">
          <img src="/logo.png" alt="Jybek Homecare Services" className="h-16 w-auto mx-auto mb-4" />
          <h1 className="text-xl font-bold mb-2" style={{ color: "#154E93" }}>Password Updated</h1>
          <p className="text-sm text-gray-500">Redirecting you to sign in…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form onSubmit={submit} className="bg-white shadow-md rounded-lg p-8 w-full max-w-sm">
        <img src="/logo.png" alt="Jybek Homecare Services" className="h-16 w-auto mx-auto mb-4" />
        <h1 className="text-xl font-bold mb-1 text-center" style={{ color: "#154E93" }}>
          Set a New Password
        </h1>
        <p className="text-sm text-gray-500 mb-6 text-center">Choose a new password for your account.</p>

        {error && (
          <div className="mb-4 text-sm bg-red-50 text-red-700 px-3 py-2 rounded">{error}</div>
        )}

        <label className="block text-sm font-medium mb-1">New Password</label>
        <div className="relative mb-4">
          <input
            type={showPassword ? "text" : "password"}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border rounded px-3 py-2 pr-16 text-sm"
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-gray-500 hover:text-gray-700"
            tabIndex={-1}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>

        <label className="block text-sm font-medium mb-1">Confirm New Password</label>
        <input
          type={showPassword ? "text" : "password"}
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-6 text-sm"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full text-white font-medium py-2 rounded"
          style={{ backgroundColor: "#154E93" }}
        >
          {loading ? "Updating…" : "Update Password"}
        </button>

        <Link to="/" className="block text-center text-xs text-gray-500 hover:text-gray-700 mt-4 underline">
          Back to Sign In
        </Link>
      </form>
    </div>
  );
}
